import { render, staticRenderFns } from "./PageAccount.vue?vue&type=template&id=2b320afe&"
import script from "./PageAccount.vue?vue&type=script&lang=js&"
export * from "./PageAccount.vue?vue&type=script&lang=js&"
import style0 from "./PageAccount.vue?vue&type=style&index=0&id=2b320afe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports